import { all, call, put, takeLatest } from 'redux-saga/effects';
import { DELETE_STORE } from 'actions/DeleteStore/actionTypes';
import {} from 'actions/DeleteStore';
import StoreApi from 'service/storeApi';
import { pushNotification } from 'utils/notifications';
import { showDeleteModalStore } from 'actions/DeleteStore';

function* deleteStore(action) {
  try {
    const response = yield call(StoreApi.delete, action.data);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, 'error', 'TOP_CENTER', 2000);
      } else {
        yield put(showDeleteModalStore(null));
        pushNotification(response.data.Message, 'success', 'TOP_CENTER', 2000);
      }
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    }
  } catch (error) {}
}

function* watchGetRequest() {
  yield takeLatest(DELETE_STORE, deleteStore);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
